import { createGlobalState } from "react-hooks-global-state";
import { Session, AuthUser } from "@supabase/supabase-js";
import { Notification } from "./types";

interface GlobalState {
  session: Session | null;
  user: AuthUser | null;
  notifications: Notification[];
}

const initialState: GlobalState = {
  session: null,
  user: null,
  notifications: [],
};

export const { useGlobalState } = createGlobalState(initialState);
